import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "informational-banner-ribbon__body" }
const _hoisted_2 = ["innerHTML"]

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import type { Locale } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationalBannerRibbon',
  props: {
  html: { type: Object as PropType<Record<Locale, string>>, required: true },
  variant: { type: String as PropType<'info' | 'warning' | 'error'>, default: 'info' },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { locale } = useI18n();

const bannerClass = computed(() => `informational-banner-ribbon--${props.variant}`);
const currentHtml = computed(() => props.html[locale.value] || props.html.en || '');

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "ribbonEl",
    class: _normalizeClass(["informational-banner-ribbon", bannerClass.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "informational-banner-ribbon__content",
        innerHTML: currentHtml.value
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("button", {
      class: "informational-banner-ribbon__close",
      "aria-label": "Close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }, [
      _createVNode(_component_ot_icon, { name: "close" })
    ])
  ], 2))
}
}

})